'use strict';

import BaseService from './base.service';

class ItemTemplatesService extends BaseService {
    /* @ngInject */
    constructor(ItemTemplate, SegaUser) {
        super(ItemTemplate, SegaUser);
    }
}

export default ItemTemplatesService;
